export const reservation = {
  status: {
    applied: "申込中",
    arranged: "手配済",
    cancel_applied: "キャンセル依頼中",
    cancelled: "キャンセル済",
  },
};
